<div>
    <app-search-icd9  (messageEvent)="receiveMessage($event)"></app-search-icd9>
    <div class="row">
        <div class="col-sm-6">
            <div class="card sidebar__common">
                <div class="card-body">
                    <mat-tree [dataSource]="dataSource"
                              [treeControl]="treeControl"
                              class="example-tree">
                        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle id="{{node.id}}">
                            <span [class.active]="isActive === node.id" class="cursor-pointer"
                                  (click)="goToDetail(node)"><b>{{node.code}}</b>: {{node.name}}</span>
                        </mat-tree-node>
                        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" id="{{node.id}}">
                            <div class="mat-tree-node">
                                <button class="btn-size-small" mat-icon-button matTreeNodeToggle
                                        (click)="getChildrenOfTree(node)"
                                        [attr.aria-label]="'Toggle ' + node">
                                    <mat-icon class="mat-icon-rtl-mirror">
                                        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                    </mat-icon>
                                </button>
                                <span [class.active]="isActive === node.id" class="cursor-pointer"
                                      (click)="goToDetail(node)"><b>{{node.code}}</b>: {{node.name}}</span>
                            </div>
                            <div [class.example-tree-invisible]="!treeControl.isExpanded(node)"
                                 role="group">
                                <!--              Same lv as parents tree LV-->
                                <ng-container matTreeNodeOutlet></ng-container>
                            </div>
                        </mat-nested-tree-node>
                    </mat-tree>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="card sidebar__common" style="min-height: 100%">
                <div class="card-body">
                    <div *ngIf="htmlRoot" [innerHTML]="htmlRoot"></div>
                   <ng-container *ngIf="isSearching; else info">
                        <div class="w-full h-full flex items-center justify-center">
                            <div class="spinner-container">
                                <div class="spinner"></div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #info>
                        <div class="main-right" *ngIf="infoModel">
                            <div
                                id="detail"
                                [innerHTML]="infoModel?.html || infoModel"
                                (click)="goToOpenTree($event)"
                            ></div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="floating-button-container">
    <button cButton [cOffcanvasToggle]="offcanvasNoBackdrop.id" class="custom-button">
        <img ngSrc="assets/images/submid.svg" alt="Góp ý Icon" class="custom-icon" height="16" width="16">
    </button>
</div>

<c-offcanvas
        id="OffcanvasNoBackdrop"
        [backdrop]="false"
        [scroll]="true"
        placement="end"
        #offcanvasNoBackdrop
        class="overflow-y-auto"
>
    <c-offcanvas-header>
        <div class="flex items-center justify-center gap-2 w-full h-fit">
            <button type="button" class="btn btn-primary w-100" (click)="toggleForm()">
                {{ showingComments ? 'Góp ý' : 'Xem góp ý' }}
            </button>
            <button
                aria-label="Close"
                cButtonClose
                class="w-10 h-10 rounded-lg hover:opacity-70 bg-red-600"
                [cOffcanvasToggle]="offcanvasNoBackdrop.id"
            >
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M18 6L6 18"
                        stroke="#ffffff"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M6 6L18 18"
                        stroke="#ffffff"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>
        </div>
    </c-offcanvas-header>
    <c-offcanvas-body>
        

        <!-- User's comment (this can be initially hidden and shown after submission) -->
        <div *ngIf="showingComments" class="mt-3" id="userComment">
            <ng-container *ngFor="let comment of userCommentList">
                <div class="mb-2" style="border-bottom: 1px solid black">
                    <div style="display: flex">
                        <p style="padding-right: 5px"><strong>{{ comment.name }}</strong></p>
                        <small class="text-muted">{{ comment.created_at }}</small>
                    </div>
                    <div style="text-decoration-line: underline;">{{ comment?.subject }}</div>
                    <div>{{ comment?.content }}</div>
                </div>
            </ng-container>
        </div>
        <div *ngIf="!showingComments">
            <div class="mb-3">
                <label for="name" class="form-label">Tên</label> <i style="color: red">*</i>
                <input type="text" class="form-control" id="name" placeholder="Tên" #nameInput>
                <div for="feedback" class="form-label" style="color: red">{{nameMessage}}</div>
            </div>

            <div class="mb-3">
                <label for="number" class="form-label">Số điện thoại</label> <i style="color: red">*</i>
                <input type="text" class="form-control" id="number" placeholder="Số điện thoại" #numberInput>
                <div for="feedback" class="form-label" style="color: red">{{phoneMessage}}</div>
            </div>

            <div class="mb-3">
                <label for="email" class="form-label">Email</label> <i style="color: red">*</i>
                <input type="email" class="form-control" id="email" placeholder="Email" #emailInput>
                <div for="feedback" class="form-label" style="color: red">{{emailMessage}}</div>
            </div>

            <div class="mb-3">
                <label for="title" class="form-label">Tiêu đề</label> <i style="color: red">*</i>
                <input type="title" class="form-control" id="title" placeholder="Tiêu đề" #titleInput>
                <div for="feedback" class="form-label" style="color: red">{{subjectMessage}}</div>
            </div>

            <div class="mb-3">
                <label for="feedback" class="form-label">Góp ý</label> <i style="color: red">*</i>
                <textarea class="form-control" id="feedback" rows="4" placeholder="Góp ý của bạn"
                          #feedbackInput></textarea>
                <div for="feedback" class="form-label" style="color: red">{{contentMessage}}</div>
            </div>

            <div for="feedback" class="form-label" style="color: red">{{errorMessage}}</div>

            <ng-container *ngIf="captchaImageUrl">
                <img [src]="captchaImageUrl" alt="Captcha Image" id="captchaImage">
                <div class="mb-3">
                    <input type="text" class="form-control" id="captcha" placeholder="Nhập Captcha"
                           [(ngModel)]="userCaptcha">
                </div>
            </ng-container>

            <!-- Submit button -->
            <button type="button" class="btn btn-primary"
                    (click)="submitForm()">
                Gửi
            </button>
        </div>
    </c-offcanvas-body>
</c-offcanvas>
